import { UploadStatuses, UPLOAD_STATUSSES } from '@shared/upload-status';
import type { UploadStatus } from '@shared/upload-status';
import type { AanvraagSoort } from '@shared/aanvraag-soort';

export { UploadStatuses, UPLOAD_STATUSSES };
export type { UploadStatus };

export const SEO = {
  DEFAULT_TITLE: 'Mister KLIC - De alles-in-één oplossing voor KLIC-meldingen',
  DEFAULT_DESCRIPTION:
    'Beheer je KLIC-meldingen op kantoor, bekijk je KLIC-meldingen op de graaflocatie en exporteer KLIC-meldingen naar AutoCAD, Revit en QGIS via DWG, Geopackage, WMS en WFS.',
  DEFAULT_IMAGE: 'assets/mister-klic-nieuws.png',
};

export const SUPPORT_EMAIL = 'support@misterklic.nl';

export const KVK = '65533135';
export const STREET = 'Nieuwegracht 2b';
export const POSTALCODE = '3512 LP';
export const CITY = 'Utrecht';

export const MAXIMUM_DAYS_BEFORE_DIGGING = 3; // Een KLIC-melding (graafmelding) mag maximaal 3 dagen van te voren worden aangevraagd.
export const MAXIMUM_DAYS_IN_ADVANCE = 20; // De graafwerkzaamheden van een KLIC-melding mogen maximaal over 20 dagen beginnen.
export const DAYS_BEFORE_VALIDITY_WARNING = 5;

export const ASSUMED_DESKTOP_WIDTH = 981;

export const DEFAULT_CREDIT_PIRCE = 13.5;

export const STATUS_TYPES: {
  alias: 'Actief' | 'Ingepland' | 'Gearchiveerd' | 'Alle';
  value: UploadStatus[];
}[] = [
  {
    alias: `Actief`,
    value: [
      'active',
      'initialised',
      'zip-uploaded',
      'unzip-started',
      'unzipped',
      'db-import-started',
      'db-imported',
      'post-processing-started',
      'failed',
      // Deprecated statusses
      'processing-upload',
      'waiting-for-etl',
      'automation-kickoff',
      'fme-is-processing',
      'workspace-failed',
    ],
  },
  {
    alias: 'Ingepland',
    value: ['planned', 'requested', 'kadaster-planned', 'kadaster-requested', 'kadaster-received'],
  },
  {
    alias: `Gearchiveerd`,
    value: ['inactive'],
  },
  {
    alias: `Alle`,
    value: [...UPLOAD_STATUSSES],
  },
] as const;

export type StatusTypeAlias = (typeof STATUS_TYPES)[number]['alias'];

export const ORDER_ITEM_STATUSSES = [
  'open',
  'waiting-for-download',
  'download-ready',
  'completed',
  'failed',
  'waiting-for-download-failed',
  'download-failed',
] as const;

export type OrderItemStatus = (typeof ORDER_ITEM_STATUSSES)[number];

// KLIC-melding specific constants
export const MAX_COORDINATES_IN_POLYGON = 50;
export const MAX_COORDINATES_IN_INFORMATION_POLYGON = 200;
export const ALLOWED_SIZE_IN_M2: Record<AanvraagSoort, number> = {
  graafmelding: 500,
  calamiteitenmelding: 500,
  orientatieverzoek: 2500,
};

export type UploadLogActionType = 'open-klic-melding' | 'geolocation-klic-viewer';

export const AANVRAAG_SOORTEN = [
  { value: 'graafmelding', alias: 'Graafmelding' },
  { value: 'calamiteitenmelding', alias: 'Calamiteitenmelding' },
  { value: 'orientatieverzoek', alias: 'Oriëntatieverzoek' },
] as const;
